import React from 'react';

const CalendarLinkButton = ({ label, testId, onClick, disabled = false, primary = false }) => (
  <button
    type="button"
    className={`te-calendar-link${primary ? ' is-primary' : ''}`}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
  >
    {label}
  </button>
);

export default CalendarLinkButton;
